<div class="data-sources">
  <h3>{{ 'Daily weather data updates' | translate }}</h3>
  <div class="sources-list">
    @for (source of sources; track source.name) {
      <p>
        <a class="source-link">
          {{ source.name | translate }}: {{ source.date | date:'dd.MM.yyyy' }}{{ source.gridStepKey ? (source.gridStepKey | translate) : '' }}
        </a>
      </p>
    }
  </div>
</div>
